import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export const Box = props => {
  const {
    children,
    borderBox = true,
    className,
    id
  } = props;
  return (
    <div
      id={id}
      className={clsx('flex flex-col justify-center items-center flex-auto h-full w-full', {'border-box': borderBox}, className)}
      style={{ minHeight: 'min-content' }}>
      {children}
    </div>
  );
};

Box.propTypes = {
  className: PropTypes.string
};

export default Box;
